<template>
<div :class="{loadingCSS : !first_loading_seat_flag}" id="main">
    <!-- 좌석 화면(메인) -->
    <div  class="main-wrap">
        <div class="reser_content">
            <div class="notice_box seat-area">
              <div class= "area-tab">
                   <nav class='seat-tab'>
                        <a class="active"  @click="main_tab('SEAT')">좌석</a>
                        <a @click="main_tab('LOCKER')">사물함</a>
                        <a @click="main_tab('GROOM')">그룹룸</a>
                    </nav>
                </div>
                <div id = 'seat-content-wrap' class="main_content_wrap hidden-scroll">
                    <template v-for="(item,index) in get_tab_code_list">
                        <div v-if="item.code_name === '좌석'" :key="index+item.code_name+'div'" class="obj obj1" :style="menu_tab_style_list['seat']">
                            <div class="tab_contents">
                                <div class="btn_wrap">
                                    <!-- 좌석 탭 선택 시작-->
                                    <div class="list_05_select">
                                        <div class="list_05_btn" v-if="tab_chk == true && tab_data.length > 1 && step != 'LOCKER'" @click="map_group_pop = true">
                                            <span>{{tab_name}}</span><font-awesome-icon :icon="['fas', 'sort-down']" />    
                                        </div>
                                    </div>
                                    <!-- 좌석 탭 선택 종료 -->
                                    <!-- 좌석 탭 선택 레이어 시작 -->
                                    <div class="list_05_select_pop_wrap" v-if="map_group_pop">
                                        <div class="list_05_select_pop">
                                            <ul>
                                                <template v-for="(item, index) in tab_data" :value="item.map_group_id">
                                                    <li v-if="tab_index !== index" @click="floor_tab(item, index)" :key="item.map_group_id">{{item.tab_name}}</li>
                                                    <li v-if="tab_index === index" @click="floor_tab(item, index)" class=" on" :key="item.map_group_id">{{item.tab_name}}</li>
                                                </template>
                                            </ul>
                                        </div>
                                    </div>
                                    <!-- 좌석 탭 선택 레이어 종료 -->
                                    <div class="btn03"  @click="out_soon"><img src="../../assets/image/seat-out-pop-icon.png" alt="">퇴실좌석</div>
                                    <div @click="refresh_seat" class="btn-refresh"><img src="../../assets/image/seat-refresh-btn-icon.png" alt=""></div>
                                    
                                </div>
                                <div class="status">
                                    <template>
                                        <p>
                                            <span class="status-color" :style="my_seat_back_color"></span>
                                            <span class="status-name">내 좌석</span>
                                        </p>
                                    </template>
                                    <!-- <p>개인석 상태:</p> -->
                                    <template v-for="(item, index) in seat_status_color">
                                        <p :key="index+'status_color'"><span class="status-color" v-bind:style="{'backgroundColor':item.style }"></span>
                                            <span class="status-name">{{item.code_name}}</span></p>
                                    </template>
                                </div>
                                <template v-if="step=='SEAT'">
                                    <div class="sit_content_wrap">
                                        <transition name="fade" v-if="fade_seat">
                                            <div class="info-scroll">
                                                <img src="../../assets/image/scroll.png" alt="">
                                            </div>
                                        </transition>
                                        <div class="sit_content" ref="seatarea">
                                            <div id="sit_view" class="sit_view_wrap">
                                                <div class="row tab_01" v-bind:style="{width:background_data.img_width + 'px', height:background_data.img_height + 'px', background:`url('${map_img}')no-repeat center 0`}">
                                                    <!-- 250717 리렌더링 이슈로 key추가함 -->
                                                    <seat 
                                                    :key="map_group_id"
                                                    :map_group_id="map_group_id" @select_seat_data="select_seat" ref="seat" @first_loading_seat="first_loading_seat"></seat>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </template>
                            </div>
                        </div>
                        <div v-else-if="item.code_name === '사물함'" :key="index+item.code_name+'div'" class="obj obj2" :style="menu_tab_style_list['locker']">
                            <div class="tab_contents">
                                <div class="btn_wrap">
                                    <div class="list_05_select w100" v-if="step == 'LOCKER'">
                                        <div class="list_05_btn" @click="map_locker_pop = true" >
                                            <span>{{sel_locker_name}}</span><font-awesome-icon :icon="['fas', 'sort-down']" />
                                        </div> 
                                    </div>
                                    <div class="list_05_select_pop_wrap" v-if="map_locker_pop">
                                        <div class="list_05_select_pop">
                                            <ul>
                                                <li v-for="(item,index) in locker_tab_data" :key="item.locker_group_id" :class="item.class" @click="floor_tab_locker(item, index)" >{{item.locker_tab_name}}</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                                <div class="status">
                                    <template>
                                        <p>
                                            <span class="status-color" :style="my_locker_back_color"></span>
                                            <span class="status-name">내 사물함</span>                                            
                                        </p>
                                    </template>
                                    <template v-for="(item,index) in locker_status_color">
                                        <p :key="index+'locker_status_color'">
                                            <span class="status-color" v-bind:style="{'background':item.color }"></span>
                                            <span class="status-name">{{item.code_name}}</span>
                                        </p>
                                    </template>
                                </div>
                                <template v-if="step=='LOCKER'">
                                    <div class="sit_content_wrap">
                                    <transition name="fade" v-if="fade_locker">
                                        <div class="info-scroll locker-info" name="fade">
                                            <img src="../../assets/image/scroll.png" alt="">
                                        </div>
                                    </transition>
                                        <div class="sit_content lock_content" ref="lockerarea">
                                            <div class="sit_view_wrap">
                                                <locker :locker_group_id="locker_group_id" @select_locker_data="select_locker" @first_loading_locker="first_loading_locker" ref="locker"></locker>
                                            </div>                                            
                                        </div>
                                    </div>
                                    
                                </template>
                            </div>
                        </div>
                        <div v-else-if="item.code_name === '그룹룸'" :key="index+item.code_name+'div'" class="obj obj3 hidden-scroll" :style="menu_tab_style_list['groom']">                            
                            <template v-if="step=='GROOM'">
                                <div class="tab_contents">
                                    <groom @first_loading_groom="first_loading_groom"></groom>
                                </div>
                            </template>
                        </div>
                    </template>
                </div>
            </div>
            <div class="choice-seat" v-if="step != 'GROOM'">
                <div class="choice-seat-wrap">
                    <img src="../../assets/image/select-btn-icon.png" alt="">
                    <div v-if="(step == 'SEAT' && !click_event_seat)">
                        <span>좌석을 선택하세요.</span>
                    </div>
                    <div v-if="(step == 'LOCKER' && !click_event_locker)">
                        <span>사물함을 선택하세요.</span>
                    </div>
                    <div v-if="(step == 'SEAT' && click_event_seat)">
                        <span class="choice-seat-info">{{seat_name}}번 좌석</span>
                        <span class="choice-seat-info-kind"> {{seat_type}}</span>                        
                        <span class="btn-choice" @click="send_data_seat">확인</span>
                    </div>
                    <div v-if="step == 'LOCKER' && click_event_locker">
                        <span class="choice-seat-info">{{locker_name}}번 사물함</span>
                        <span class="btn-choice" @click="send_data_locker">확인</span>
                    </div>
                </div>
            </div>           
           
            <div class="loading" v-show="loading">
                <img src="../../assets/image/loading.gif">
            </div>
        </div>
    </div>

    <!-- <modals-container /> -->
</div>
</template>

<script>
import vue from 'vue';

// 사용자 정의 모듈.
import * as config from '../../javascript/config';
// 좌석 / 사물함 / 그룹룸
import locker from '../components/locker';
import seat from '../components/seat';
import groom from '../components/group_room';

vue.component('seat', seat);
vue.component('groom', groom);
vue.component('locker', locker);

export default {
    name: 'Main',  
    data() {
        return {
            sign_id: 'lw1135',
            sign_password: '0000',
            store_id: '',
            tab_index: 0,
            locker_tab_index: 0,
            // 메인 출력 화면 스탭
            step: '', // 좌석 정보 / 사물함 정보 / 그룹룸 정보를 표기하기위한 스탭

            // 탭(층) 관련
            tab_data: Object, // 탭(층) 정보
            map_img: '',
            tab_chk: true, // 좌석 / 사물함 일때만 탭(층)정보를 표시하기 위한 flag
            map_group_id: '', // 탭(층) 에 대한 id 를 담을 변수 - 사용처 => 탭클릭시 id를 담고 seat / locker 쪽에 탭 id 전달
            // 사물함 (맵) 관련 2020 09 01
            locker_tab_data: Object, // 탭 정보
            locker_group_id: '',
            // 좌석별 컬러 (범례)
            seat_status_color: [],
            seat_type_color: [],
            // 그룹룸 별 컬러 (범례)
            groom_status_color: [],
            groom_type_color: [],

            // 사물함 별 컬러(범례)
            locker_status_color: [],

            // keyboard or num-pad 설정.
            current_focus: null,
            parent_key_str: '',
            //좌석 / 사물함 / 그룹룸 탭
            get_tab_code_list: [],
            menu_tab_style_list: {
                'seat': 'display:block;',
                'locker': 'display:none;',
                'groom': 'display:none;',
                'mileage': 'display:block;'
            },
            groom_cnt: this.$store.getters.get_store_groom_cnt,
            main_page_tab_code: '',

            my_seat_back_color: '',
            my_locker_back_color: '',
            store_bg_image: '',
            background_data: [],

            click_event_seat: false,
            click_event_locker: false,
            seat_name: '',
            seat_type: '',
            locker_name: '',
            select_seat_data: {},
            select_locker_data: {},
            floor_index: 1,
            left_btn: false,
            right_btn: false,
            tab_data_all: [],
            fade_seat: null,
            fade_locker: null,
            user_id: '',
            user_password: '',
            loading: false,
            store_pay_yn: this.$store.getters['getStore_pay_info'],

            first_locker_loading_chk: false,

            tab_name: '',
            map_group_pop: false,
            first_loading_seat_flag: false,
            map_locker_pop : false,
            sel_locker_name : '',
            // 코드 추가 - 2020-12-23
            promotion_yn: this.$store.state.mobile_promotion_yn.value

        }
    },
    methods: {
        first_loading_groom() {
            this.first_loading_seat_flag = true;
        },
        first_loading_locker() {
            this.first_locker_loading_chk = true;

            this.loading = true;
            let self = this;
            this.render_locker_group_id(this.locker_group_id, (result) => {
                self.$refs.locker[0].refresh_from_main(500, (result) => {
                    var area = this.$refs.lockerarea[0];
                    self.loading = result;
                    if ((area.scrollHeight == 0 && area.clientHeight == 0) || (area.scrollHeight > area.clientHeight)) {
                        self.fade_locker = true;
                        this._fade('locker');
                    } else if ((area.scrollWidth == 0 && area.clientWidth == 0) || (area.scrollWidth > area.clientWidth)) {
                        self.fade_locker = true;
                        this._fade('locker');
                    } else {
                        self.fade_locker = false;
                    }
                })
            })
            this.first_loading_seat_flag = true;
        },
        first_loading_seat() {
            this.select_seat_map_group();
            this.first_loading_seat_flag = true;
        },
        refresh_seat() {
            this.loading = true;
            this.$refs.seat[0].refresh_from_main(1000, (result => {
                this.loading = result;
            }));
        },
        _fade(val) {
            var self = this;

            if (val == 'seat') {
                setTimeout(function () {
                    self.fade_seat = false;
                }, 2000); // hide the message after 3 seconds
            } else if (val == 'locker') {
                setTimeout(function () {
                    self.fade_locker = false;
                }, 2000); // hide the message after 3 seconds
            }

        },
        _step(val) {
            this.floor_index = this.floor_index + val;
            if (this.floor_index == 1) {
                this.left_btn = false;
            } else if (this.floor_index > 1) {
                this.left_btn = true;
            }

            for (let i = 0; i < this.tab_data.length; i++) {
                if (this.tab_data[i].floor_index == this.floor_index) {
                    this.floor_tab(this.tab_data[i]);
                    this.tab_index = i;
                    break;
                }
            }
            if (this.tab_data[this.tab_data.length - 1].floor_index == this.floor_index) {
                this.right_btn = false;
            } else {
                this.right_btn = true;
            }

        },
        select_locker(item) {
            this.click_event_locker = true;
            this.locker_name = item.locker_name;
            this.select_locker_data = item;
        },
        send_data_locker() {
            if (this.store_pay_yn) {
                // 251127 모바일 사물함 결제 활성화 여부 체크
                if(!this.get_m_locker_pay_yn){
                    const alert_param = {
                        code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                        message: `현재 모바일에서 사물함 구매가 제한되어 있습니다.`
                    };
                    this.$store.commit('set_popup_type', alert_param);
                    return; 
                }
                this.$refs.locker[0].send_data(this.select_locker_data);
            } else {
                const alert_param = {
                    code: this.$store.getters['get_popup_code'].POPUP_ALERT,
                    message: `서비스 준비중 입니다.`,
                    router: '',
                };
                this.$store.commit('set_popup_type', alert_param);
            }
        },
        select_seat(item) {
            this.click_event_seat = true;
            this.seat_name = item.seat_name;
            this.seat_type = item.seat_type_name;
            this.select_seat_data = item;
        },
        send_data_seat() {
            this.$refs.seat[0].send_data(this.select_seat_data);
        },
        main_tab(val) {
      
            // this.fade_seat = true;
            // this.fade_locker = true;
            this.step = val;
            
            if (this.step == "GROOM") {
            	if(this.groom_cnt <= 0){
					// 그룹룸이 없는 매장의 경우 groom_cnt 의 값으로 좌석배치도에서 그룹룸 선택시 그룹룸 없는 매장이라는 팝업 띄움 2020.11.29
				    const alert_param = {
					code: this.$store.getters['get_popup_code'].POPUP_ALERT,
					message: `해당매장은 그룹룸이 없습니다. `,
				    };
				    this.$store.commit('set_popup_type', alert_param);
					return;
					
				}else{
                	this.tab_chk = false;
               	}               	
            } else {
                this.tab_chk = true;
            }
            if (this.step == "GROOM") {
                this.menu_tab_style_list['seat'] = 'display:none;'
                this.menu_tab_style_list['groom'] = 'display:block;'
                this.menu_tab_style_list['locker'] = 'display:none;'

            } else if (this.step == "SEAT") {
                this.menu_tab_style_list['seat'] = 'display:block;'
                this.menu_tab_style_list['groom'] = 'display:none;'
                this.menu_tab_style_list['locker'] = 'display:none;'
                this._fade('seat');
            } else if (this.step == "LOCKER") {
                this.menu_tab_style_list['seat'] = 'display:none;'
                this.menu_tab_style_list['groom'] = 'display:none;'
                this.menu_tab_style_list['locker'] = 'display:block;'
                this._fade('locker');
            }
            this.click_event_seat = false; // 탭 클릭시 좌석 및 사물함 레이어 숨김처리 2020.11.24 cjb
            this.click_event_locker = false; // 탭 클릭시 좌석 및 사물함 레이어 숨김처리 2020.11.24 cjb
        },
        floor_tab(item, index) {
            this.background_data = item;
            this.map_img = config.SYS_HOST + `/images/kiosk/${item.map_img}`;
            this.map_group_id = item.map_group_id;
            this.tab_index = index;
            this.map_group_pop = false;
            this.tab_name = item.tab_name;
            this.click_event_seat = false;            
            if (this.first_loading_seat_flag) {
                this.select_seat_map_group();
            }

        },
        floor_tab_locker(item, index) {
            for (let i = 0; i < this.locker_tab_data.length; i++) {
                if (item.locker_group_id == this.locker_tab_data[i].locker_group_id) {
                    this.locker_tab_data[i].class = 'on';
                } else {
                    this.locker_tab_data[i].class = 'over';
                }
            }

            this.locker_group_id = item.locker_group_id;
            this.locker_tab_index = index;
            if (this.first_locker_loading_chk) {
                this.loading = true;
                let self = this;
                this.render_locker_group_id(item.locker_group_id, (result) => {
                    self.$refs.locker[0].refresh_from_main(500, (result) => {
                        var area = this.$refs.lockerarea[0];
                        self.loading = result;
                        if ((area.scrollHeight == 0 && area.clientHeight == 0) || (area.scrollHeight > area.clientHeight)) {
                            self.fade_locker = true;
                            this._fade('locker');
                        } else if ((area.scrollWidth == 0 && area.clientWidth == 0) || (area.scrollWidth > area.clientWidth)) {
                            self.fade_locker = true;
                            this._fade('locker');
                        } else {
                            self.fade_locker = false;
                        }
                    })
                })
            }
            this.sel_locker_name = item.locker_tab_name;
            this.map_locker_pop = false;
        },
        start_load() {
            this.$router.push('/start');
        },
        out_soon() {
            const alert_param = {
                code: this.$store.getters['get_popup_code'].POPUP_OUT_SOON,
            };
            this.$store.commit('set_popup_type', alert_param);
            return;
        },
        reset_seat_type_status() {
            // 좌석 타입 및 상태별 색 요청

            this.seat_type_color = this.$store.getters['get_seat_type_color'];
            for (var i = 0; i < this.seat_type_color.length; i++) {
                var color = this.seat_type_color[i].color || "";
                if (color == "") {
                    this.seat_type_color[i].color = "#000000";
                } else {
                    this.seat_type_color[i].color = color;
                }
            }

            this.seat_status_color = this.$store.getters['get_seat_status_color'];
            // for (var i = 0; i < this.seat_status_color.length; i++) {
            //     var colorStr = "";
            //     var color = this.seat_status_color[i].color || "";
            //     if (color == "" || color == "null" || color == null) {
            //         this.seat_status_color[i].color = "#000000";
            //         colorStr = "#000000";
            //     } else {
            //         if (color.indexOf(",") != -1) {
            //             this.seat_status_color[i].color = this.seat_status_color[i].color.split(',')[0];
            //             colorStr = this.seat_status_color[i].color.split(',')[0];
            //         } else {
            //             colorStr = this.seat_status_color[i].color
            //         }
            //     }
            //     this.seat_status_color[i].style = "solid 4px " + colorStr;
            // }

            this.locker_status_color = this.$store.getters['get_locker_status_color'];
            for (var i = 0; i < this.locker_status_color.length; i++) {
                var colorStr = "";
                var color = this.locker_status_color[i].color || "";
                if (color == "" || color == "null") {
                    this.locker_status_color[i].color = "#000000";
                    colorStr = "#000000";
                } else {
                    if (color.indexOf(",") != -1) {
                        this.locker_status_color[i].color = this.locker_status_color[i].color.split(',')[0];
                        colorStr = this.locker_status_color[i].color.split(',')[0];
                    } else {
                        colorStr = this.locker_status_color[i].color
                    }
                }
                this.locker_status_color[i].style = colorStr;
            }

        },
        reset_groom_type_status() {
            // 좌석 타입 및 상태별 색 요청
            this.groom_type_color = this.$store.getters['get_groom_type_color'];
            for (var i = 0; i < this.groom_type_color.length; i++) {
                var color = this.groom_type_color[i].color || "";
                if (color == "") {
                    this.groom_type_color[i].color = "#000000";
                }
            }
            this.groom_status_color = this.$store.getters['get_seat_status_color'];
            for (var i = 0; i < this.groom_status_color.length; i++) {
                var colorStr = "";
                var color = this.groom_status_color[i].color || "";
                if (color == "" || color == "null") {
                    this.groom_status_color[i].color = "#000000";
                    colorStr = "#000000";
                } else {
                    if (color.indexOf(",") != -1) {
                        this.groom_status_color[i].color = this.groom_status_color[i].color.split(',')[0];
                        colorStr = this.groom_status_color[i].color.split(',')[0];
                    } else {
                        colorStr = this.groom_status_color[i].color
                    }
                }
                this.groom_status_color[i].style = colorStr;
            }
        },
        get_seat_type_color_count() {
            const type = config.REQ_SEAT_USER_GET_TYPE_COLOR_LIST;
            const req_data = {
                map_group_id: this.map_group_id
            };
            this.$store.dispatch(type.action_name, {
                type: type,
                data: req_data
            }).then(response => {
                this.$store.commit('set_seat_type_color', response.data);
                this.seat_type_color = response.data
            }).catch(function (error) {
                console.log('error=============>', error);
            });
        },        	
        // 코드 추가 - 2020-12-09	
        auto_login() {	
            this.loading = true;
            if(this.promotion_yn){
                if (this.user_id != '') {
                // 로그인하기
                const type = config.REQ_MEMBER_PROMOTION_TO_LOGIN;
                const data = {
                    data: {
                        'user_id': this.user_id,
                    }
                }; // store_id는 공통으로 추가하니까 생략. 예) {user_id: 123}	
                this.$store.dispatch(type.action_name, {
                    type: type,
                    data: data
                    // }).then(function (response) { // => this.$store를 인식하지 못하는 문제로 아래 코드 사용.	
                }).then((response) => {
                    // 이용제한 사용자 입니다. 관리자에게 문의하세요.
                        this.$store.commit('set_user', {
                            user: response.userInfo
                        });
                        this.$store.commit('set_store_list', {
                            store_list: response.storeList
                        });
                        //this.$store.state.login_chk = true;
                        this.$store.commit('change_login_chk', {
                            value: true
                        });
                        this.$store.commit('set_Item_register_info', {
                            id: '',
                            pass: '',
                            flag: false
                        });
                        var router = this.$router;
                        let that = this;
                        return new Promise(function (resolve, reject) {
                            resolve(resolve);
                        })
                        .then(result => {
                            this.$store.commit('set_store_info', {
                                store_info: response.storeInfo
                            });
                            this.$store.commit('change_main_start_chk', {
                                value: true
                            });
                            return this.$store.dispatch(config.ACT_GET_INIT_DATA);
                        })
                        .then(result => {
                                this.$store.commit('set_page_header_init', {
                                    style: 'block'
                                });
                                this.$router.push('/front_main');
                                this.loading = false;
                            });
                        }).catch(function (error) {
                            console.log('error=============>', error);
                    });
                }
            }else{
                if (this.user_id != '' && this.user_password != '') {
                    // 로그인하기
                    const type = config.REQ_MEMBER_LOGIN;
                    const data = {
                        data: {
                            'user_hp': this.user_id,
                            'password': this.user_password
                        }
                    }; // store_id는 공통으로 추가하니까 생략. 예) {user_id: 123}	
                    this.$store.dispatch(type.action_name, {
                        type: type,
                        data: data
                        // }).then(function (response) { // => this.$store를 인식하지 못하는 문제로 아래 코드 사용.
                    }).then((response) => {
                        // 이용제한 사용자 입니다. 관리자에게 문의하세요.
                        if (response.result && response.data.userInfo.blacklist_yn != 1) {
                            this.$store.commit('set_user', {
                                user: response.data.userInfo
                            });
                            this.$store.commit('set_store_list', {
                                store_list: response.data.storeList
                            });
                            //this.$store.state.login_chk = true;
                            this.$store.commit('change_login_chk', {
                                value: true
                            });
                            this.$store.commit('set_Item_register_info', {
                                id: '',
                                pass: '',
                                flag: false
                            });
                            var router = this.$router;
                            if (!response.data.default_store_yn) {
                                router.push('/store');
                            } else {
                                // router.push('/');
                                let that = this;
                                return new Promise(function (resolve, reject) {
                                        resolve(resolve);
                                    })
                                    .then(result => {
                                        this.$store.commit('set_store_info', {
                                            store_info: response.data.storeInfo
                                        });
                                        this.$store.commit('change_main_start_chk', {
                                            value: true
                                        });
                                        return this.$store.dispatch(config.ACT_GET_INIT_DATA);
                                    })
                                    .then(result => {
                                        this.$store.commit('set_page_header_init', {
                                            style: 'block'
                                        });
                                        this.$router.push('/front_main');
                                    });
                            }
                        }
                    }).catch(function (error) {
                        console.log('error=============>', error);
                    });
                }
            }
        },
        select_seat_map_group() {
            var group_id = this.map_group_id;
            this.loading = true;
            let self = this;
            this.render_map_group_id(group_id, (result) => {
                self.$refs.seat[0].refresh_from_main(500, (result) => {
                    self.loading = result;
                    var area = self.$refs.seatarea[0];
                    if ((area.scrollHeight == 0 && area.clientHeight == 0) || (area.scrollHeight > area.clientHeight)) {
                        self.fade_seat = true;
                        this._fade('seat');
                    } else if ((area.scrollWidth == 0 && area.clientWidth == 0) || (area.scrollWidth > area.clientWidth)) {
                        self.fade_seat = true;
                        this._fade('seat');
                    } else {
                        self.fade_seat = false;
                    }

                })
            })

        },
        render_map_group_id(id, callback) {
            for (let i = 0; i < this.tab_data.length; i++) {
                if (id == this.tab_data[i].map_group_id) {
                    this.background_data = this.tab_data[i];
                    this.map_img = config.SYS_HOST + `/images/kiosk/${this.tab_data[i].map_img}`;
                    this.tab_index = i;
                }
            }
            // this.map_group_id = id;
            this.get_seat_type_color_count();
            callback(false);
        },

        render_locker_group_id(id, callback) {
            callback(false);
        },

    },
    computed: {
        get_step_info() {
            return this.step;
        },
        get_store_groom_cnt() {
            return this.$store.getters.get_store_groom_cnt;
        },
        get_main_page_tab_code() {
            return this.$store.getters.get_main_page_tab_code;
        },
        live_seat_type_color() {
            this.seat_type_color.seat_using_count = this.$store.state.seat_type_color.seat_using_count;
            return this.seat_type_color;
        },
        getloading(){
            return this.first_loading_seat_flag;
        },
        // 251127 모바일에서 사물함 활성화 여부 추가
        get_m_locker_pay_yn(){
            return this.$store.getters['get_store_option'].m_locker_pay_yn && this.$store.getters['get_store_option'].m_locker_pay_yn == 1 ? true : false;
        }
    },
    mounted() {
        var temp_store_bg_image = this.$store.getters['getStoreInfo']['store_bg_img'];
        if (typeof temp_store_bg_image == 'undefined' || temp_store_bg_image == '') {
            temp_store_bg_image = '';
        } else {
            temp_store_bg_image = config.SYS_HOST + '/images/kiosk/bg/' + temp_store_bg_image;
        }
        this.store_bg_image = temp_store_bg_image;
        this.$nextTick(function () {
            var temp_my_seat_color = this.$store.getters['get_my_color']['my_seat_color']
            var temp_my_locker_color = this.$store.getters['get_my_color']['my_locker_color']
            if (typeof temp_my_seat_color == 'undefined' || temp_my_seat_color == '') {
                temp_my_seat_color = 'red';
            } else {
                if (temp_my_seat_color.indexOf(",") != -1) {
                    var color = temp_my_seat_color.split(',');
                    temp_my_seat_color = color[0];
                }
            }
            this.my_seat_back_color = 'background-color : ' + temp_my_seat_color;
            this.my_locker_back_color = 'background-color : ' + temp_my_locker_color;
	
            // 로그인(홍보앱)
            var self = this;
            try {
                window.android.kioskAutoLoginCheck();
            } catch (error) {
                console.log('error :::::::: ', error)
                this.promotion_yn = true;
                this.$store.commit('set_mobile_promotion_yn', {
                    value: true
                });
            }
            if(this.promotion_yn){
                if (cmmnGetConnectDevice() == 'mobile') {
                    var callbackTemplate = function (result) {	
                        var token = self.$store.getters['getKioskToken'];
                        if (typeof token == "undefined" || token == null || token == "") {
                            self.user_id = result.user_id;
                            self.auto_login();	
                        }	
                    };
                    try{
                        reqKioskLoginData(callbackTemplate);
                    }catch(e){                        
                    }
                } else {	
                    // 키오스크 signin 체크	
                    var token = self.$store.getters['getKioskToken'];	
                    if (typeof token == "undefined" || token == null || token == "") {	
                        self.$router.push('/start');	
                        return;	
                    }
                }	
            // 자동 로그인(키오스크모바일)	
            }else{	
                if (cmmnGetConnectDevice() == 'mobile') {	
                    var callbackTemplate = function (result) {	
                        var token = self.$store.getters['getKioskToken'];	
                        if (typeof token == "undefined" || token == null || token == "") {	
                            if (result.auto) {	
                                self.user_id = result.user_id;	
                                self.user_password = result.password;	
                                self.auto_login();	
                            } else {	
                                self.$router.push('/start');	
                                return;	
                            }	
                        }	
                    };	
                    autoLoginConfirm(callbackTemplate);	
                } else {
                    // 키오스크 signin 체크	
                    var token = self.$store.getters['getKioskToken'];	
                    if (typeof token == "undefined" || token == null || token == "") {	
                        self.$router.push('/start');	
                        return;	
                    }	
                }	
            }
            this.$store.commit('set_Last_URL', '/');

            //메인 페이지 가 렌더링 될때마다 메인 start 값 체크 후 시작하기 화면을 보여줄지 좌석 화면을 보여줄지 판단
            if (this.$store.state.main_start_chk) {
                this.menu_tab_style_list['seat'] = 'display:none;'
                this.menu_tab_style_list['groom'] = 'display:block;'
                this.menu_tab_style_list['locker'] = 'display:none;'
            }
            // 상품구매 쪽에서 main tab chk 값을 조작후 메인 페이지 올때마다 좌석/사물함/그룹룸 탭의 기본 값을 변경
            if (this.$store.state.main_tab_chk == 0) {
                this.step = "SEAT";
                this.menu_tab_style_list['seat'] = 'display:block;'
                this.menu_tab_style_list['groom'] = 'display:none;'
                this.menu_tab_style_list['locker'] = 'display:none;'
            } else if (this.$store.state.main_tab_chk == 1) {
                this.step = "LOCKER";
                this.menu_tab_style_list['seat'] = 'display:none;'
                this.menu_tab_style_list['groom'] = 'display:none;'
                this.menu_tab_style_list['locker'] = 'display:block;'
            } else {
                this.step = "GROOM";
                this.menu_tab_style_list['seat'] = 'display:none;'
                this.menu_tab_style_list['groom'] = 'display:block;'
                this.menu_tab_style_list['locker'] = 'display:none;'
                this.tab_chk = false;
            }

            // 탭(층) 정보 요청.                         
            this.tab_data = this.$store.getters['get_map_group_list'];
            this.locker_tab_data = this.$store.getters['get_locker_group_list']; // 2020 09 01
            this.get_tab_code_list = this.$store.getters['get_tab_code_list'];

            
            

            // 탭(층) 관련로직
            if (this.tab_data.length != 0) {
                var floor_index = 0;
                var floor_group = 1;
                for (let i = 0; i < this.tab_data.length; i++) {
                    this.tab_data[i].tab_name_main = this.tab_data[i].tab_name;

                    //     this.tab_data[i].floor_index = floor_group;
                    //     floor_index++
                    //     if (floor_index % 2 == 0) {
                    //         ++floor_group
                    //         this.right_btn = true;
                    //     }
                    // }
                    // if (this.tab_data[this.tab_data.length - 1].floor_index == this.floor_index) {
                    //     this.right_btn = false;
                    // } else {
                    //     this.right_btn = true;
                }

                this.floor_tab(this.tab_data[0]);                
                this.tab_index = 0;
                if(this.tab_data.length > 1){
                    this.map_group_pop = true;
                }
            }
            // 탭(층) 관련로직

            if (this.locker_tab_data.length != 0) {
                this.floor_tab_locker(this.locker_tab_data[0]);
                this.locker_tab_index = 0;
                if(this.locker_tab_data.length > 1){
                    this.map_locker_pop = true;
                }
                // for(var key in this.locker_tab_data){
                //     console.log(this.locker_tab_data[key]);
                // }
                this.locker_tab_data[0].class = "on";
                this.sel_locker_name = this.locker_tab_data[0].locker_tab_name;
            }
            // 좌석 (상태, 타입별), 사물함
            // this.reset_groom_type_status();
            this.reset_seat_type_status();
            this.$store.commit('set_main_page_top_menu_code', {
                'menu_code': "CHOOSE"
            });
        });

        if (this.$store.getters['get_groom_reservation_pay']) {
            this.$store.commit('set_popup_type', {
                code: this.$store.getters['get_popup_code'].POPUP_GROOM_RESERVATION_PAY,
                message: null,
                router: '/'
            });
        }
    },
    watch: {
        getloading(){
        },
        get_step_info(kind) {            
            let menu_list = document.querySelectorAll('.seat-tab a');
            menu_list.forEach(e => {
                if(e.classList.length > 0){
                    e.classList.remove('active');
                }
            });
            let idx = 0;
            switch(kind){
                case "SEAT" :
                    idx = 0;
                    break;
                case "LOCKER" :
                    idx = 1;
                    break;
                case "GROOM" :
                    idx = 2;
                    break;
            }
            menu_list[idx].classList.add('active');
        },
        locker_group_id(id) {
            this.locker_group_id = id;
        },
        map_group_id(id) {
            // this.map_group_id = id;

        },
        get_store_groom_cnt() {
            this.groom_cnt = this.$store.getters.get_store_groom_cnt;
        },
        get_main_page_tab_code() {
            if (this.$store.getters.get_main_page_tab_code.main_page_code == "GROOM") {
                this.step = this.$store.getters.get_main_page_tab_code.main_page_code;
                this.menu_tab_style_list['seat'] = 'display:none;'
                this.menu_tab_style_list['groom'] = 'display:block;'
                this.menu_tab_style_list['locker'] = 'display:none;'
                this.tab_chk = false;
            }
        },
        seat_status_color() {
            for (var i = 0; i < this.seat_status_color.length; i++) {
                var colorStr = "";
                var color = this.seat_status_color[i].color || "";
                if (color == "" || color == "null" || color == null) {
                    this.seat_status_color[i].color = "#000000";
                    colorStr = "#000000";
                } else {
                    if (color.indexOf(",") != -1) {
                        this.seat_status_color[i].color = this.seat_status_color[i].color.split(',')[0];
                        colorStr = this.seat_status_color[i].color.split(',')[0];
                    } else {
                        colorStr = this.seat_status_color[i].color
                    }
                }
                this.seat_status_color[i].style = colorStr;
            }
        },
    }

}
</script>

<style>
.fade-enter-active,
.fade-leave-active {
    transition: opacity 1s
}

.fade-enter,
.fade-leave-to
/* .fade-leave-active in <2.1.8 */

    {
    opacity: 0
}
.loadingCSS{
    visibility: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/page/main.vue